
import DistrictType from '../types/filers/districtType';

export function getDistrictTypeList(type: string): Promise<DistrictType[]> {
    try {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/districts`)
            .then(result => result.json())
            .then(result => {
                const list = result?.filter((district: DistrictType) => district.office === type);
                return list;
            });
    } catch (error) {
        console.error('Uncaught Error:', error);
        return Promise.reject(error);
    }

};
